/**
 * Enum for Browser breakpoint
 * @readonly
 * @enum {String}
 */
export default Object.freeze({
  TABLET: '768',
  DESKTOP: '1024',
})
